import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

const DataTableEditableCell = (props: any) => {
	const [value, setValue] = useState();

	const onChange = (e: any) => {
		setValue(e.target.value);
	};

	const onBlur = () => {
		props.cell.column.onUpdate(props.row.index, value);
	};

	useEffect(() => {
		setValue(props.cell.value);
	}, [props.cell.value]);

	return <Form.Control value={value} onChange={onChange} onBlur={onBlur} />;
};

export default DataTableEditableCell;
